<template>
  <div>
    <div
      v-if="releases.length"
      :class="`${classNames} d-flex align-items-start flex-lg-column flex-md-column`"
    >
      <div class="expand-text">
        {{ releases[0] }}
      </div>
      <div class="expand-btn">
        <span
          v-if="releases.length>1"
          class="clickable color-blue"
          @click="showReleases"
        >
          <i class="fas fa-plus-circle" />
        </span>
      </div>
    </div>
    <b-modal
      id="releasesModal"
      ref="releasesModal"
      hide-footer
      hide-header
      size="xl"
    >
      <div
        v-for="(release,i) in releases"
        :key="i"
        class="medium"
      >
        <span class="medium-bold">{{ release }}</span>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
  .expand-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
    max-height: 42px;
  }

  .expand-btn {
    text-align: center;
    margin-top: 5px;
    margin-bottom: 5px;
  }
</style>
<script>
export default {
  name: "ReleaseNames",
  props: ["releases", "classNames"],
  methods: {
    showReleases () {
      this.$refs.releasesModal.show()
    },
  }
}
</script>

